<app-chart
  [title]="'mainDashboardPage.riskMappingScoreWidget.title' | labelsProvider"
  [tooltip]="'mainDashboardPage.riskMappingScoreWidget.tooltip' | labelsProvider"
>
  <div class="container">
    <div
      class="business-criticality-title"
      [matTooltip]="'mainDashboardPage.riskMappingScoreWidget.businessCriticalityHoverMsg' | labelsProvider"
      matTooltipPosition="left"
      matTooltipClass="tooltip-container"
    >
      {{ 'mainDashboardPage.riskMappingScoreWidget.businessCriticality' | labelsProvider }}
    </div>
    <div class="grid">
      <div class="severity-title v">
        {{ 'common.high' | labelsProvider }}
      </div>
      <div class="item healthy-risk row-margin" (click)="goToInventoryPage('high', 'healthy')">
        {{ getScoresData('high', 'healthy') }}
      </div>
      <div class="item medium-risk row-margin" (click)="goToInventoryPage('high', 'low')">
        {{ getScoresData('high', 'low') }}
      </div>
      <div class="item high-risk row-margin" (click)="goToInventoryPage('high', 'medium')">
        {{ getScoresData('high', 'medium') }}
      </div>
      <div class="item critical-risk row-margin" (click)="goToInventoryPage('high', 'high')">
        {{ getScoresData('high', 'high') }}
      </div>

      <div class="severity-title v">
        {{ 'common.medium' | labelsProvider }}
      </div>
      <div class="item healthy-risk row-margin" (click)="goToInventoryPage('medium', 'healthy')">
        {{ getScoresData('medium', 'healthy') }}
      </div>
      <div class="item low-risk row-margin" (click)="goToInventoryPage('medium', 'low')">
        {{ getScoresData('medium', 'low') }}
      </div>
      <div class="item medium-risk row-margin" (click)="goToInventoryPage('medium', 'medium')">
        {{ getScoresData('medium', 'medium') }}
      </div>
      <div class="item high-risk row-margin" (click)="goToInventoryPage('medium', 'high')">
        {{ getScoresData('medium', 'high') }}
      </div>

      <div class="severity-title v">
        {{ 'common.low' | labelsProvider }}
      </div>
      <div class="item healthy-risk" (click)="goToInventoryPage('low', 'healthy')">
        {{ getScoresData('low', 'healthy') }}
      </div>
      <div class="item minimal-risk" (click)="goToInventoryPage('low', 'low')">
        {{ getScoresData('low', 'low') }}
      </div>
      <div class="item low-risk" (click)="goToInventoryPage('low', 'medium')">
        {{ getScoresData('low', 'medium') }}
      </div>
      <div class="item medium-risk" (click)="goToInventoryPage('low', 'high')">
        {{ getScoresData('low', 'high') }}
      </div>

      <div></div>
      <!-- grid spacer -->
      <div class="severity-title h">
        {{ 'common.healthy' | labelsProvider }}
      </div>
      <div class="severity-title h">
        {{ 'common.low' | labelsProvider }}
      </div>
      <div class="severity-title h">
        {{ 'common.medium' | labelsProvider }}
      </div>
      <div class="severity-title h">
        {{ 'common.high' | labelsProvider }}
      </div>

      <div></div>
      <!-- grid spacer -->
      <div
        class="security-risk-title"
        [matTooltip]="'mainDashboardPage.riskMappingScoreWidget.securityRiskHoverMsg' | labelsProvider"
        matTooltipPosition="below"
        matTooltipClass="tooltip-container"
      >
        {{ 'mainDashboardPage.riskMappingScoreWidget.securityRisk' | labelsProvider }}
      </div>
    </div>

    <div class="legend">
      <div class="item-color critical-risk"></div>
      <div class="item-text">
        {{ 'mainDashboardPage.riskMappingScoreWidget.criticalRisk' | labelsProvider }}
      </div>
      <div class="item-color high-risk"></div>
      <div class="item-text">
        {{ 'mainDashboardPage.riskMappingScoreWidget.highRisk' | labelsProvider }}
      </div>
      <div class="item-color medium-risk"></div>
      <div class="item-text">
        {{ 'mainDashboardPage.riskMappingScoreWidget.mediumRisk' | labelsProvider }}
      </div>
      <div class="item-color low-risk"></div>
      <div class="item-text">
        {{ 'mainDashboardPage.riskMappingScoreWidget.lowRisk' | labelsProvider }}
      </div>
      <div class="item-color minimal-risk"></div>
      <div class="item-text">
        {{ 'mainDashboardPage.riskMappingScoreWidget.minimalRisk' | labelsProvider }}
      </div>
      <div class="item-color healthy-risk"></div>
      <div class="item-text">
        {{ 'mainDashboardPage.riskMappingScoreWidget.healthyRisk' | labelsProvider }}
      </div>
    </div>
  </div>
</app-chart>
